var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fail",style:(_vm.cssProps())})
}
var staticRenderFns = []

export { render, staticRenderFns }